import React from 'react';
import { getResourceElement } from './action-text-attachment';
import './styles.css';

const ContentHTML = ({ element }) => {

  return (
    <div className="content-html-container">
      {
        element && element?.content ?
          getResourceElement(element) : null
      }
    </div>
  )
}

export default ContentHTML;